import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import axios from 'axios';
import { toast } from 'react-toastify';

const TempSwitch = () => {
    const [isOn, setIsOn] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem("temp-switch-isOn");
        if(saved !== null) {
            setIsOn(JSON.parse(saved));
        }
    }, []);

    const handleToggle = async (e) => {
        const newState = !e.target.checked;
        setLoading(true);
        setIsOn(newState);
        localStorage.setItem("temp-switch-isOn", JSON.stringify(newState));

        const payload = {
            topic: "esp6201",
            message: {
                state: newState ? "M-ON2".toUpperCase() : "M-OFF2".toUpperCase(),
            },
        };
        
        try {
            await axios.post(
                process.env.REACT_APP_IOT_RELAY_ENDPOINT,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            
            toast.success(`Temperature turned ${newState ? 'OFF' : 'ON'} successfully.`);
        } catch(err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        checked={!isOn}
                        color="primary"
                        onChange={handleToggle}
                        disabled={loading}
                    />
                }
                label={isOn ? "Temperature Off" : "Temperature On"}
            />
        </>
    );
}

export default TempSwitch;
